module.exports = __webpack_public_path__ + "img/notice.87f72b8c.png";